module.exports = __webpack_public_path__ + "img/03.962e3a05.png";